import { useMemo } from 'react';

export const useCanManage = () => {
  const canManage = useMemo(() => {
    const canManageValue = localStorage.getItem('can_manage');
    if (canManageValue === null) {
      return true;
    }
    return canManageValue === 'true';
  }, []);

  return canManage;
};
